<div
  class="landing"
  [style.background-color]="config.general?.background_color"
>
  <div class="landing-container">
    <header
      class="landing-header"
      [style.background-color]="config.header?.background_color"
      [style.color]="config.header?.text_color"
    >
      <img *ngIf="config.header?.image" [src]="config.header.image" alt="logo" />
      <h1>{{ config.header?.title }}</h1>
    </header>

    <main class="landing-body">
      <section class="landing-intro">
        <div class="landing-instructions">
          <h2>Instrucciones</h2>
          <p>{{ config.body?.intructions }}</p>
        </div>
        <img *ngIf="config.body?.image" class="landing-banner" [src]="config.body.image" alt="banner" />
      </section>

      <nav class="landing-tabs" *ngIf="sections.length">
        <button
          type="button"
          class="landing-tab"
          *ngFor="let section of sections; let i = index"
          [class.active]="i === selectedSection"
          (click)="selectedSection = i"
        >
          <span class="material-icons" *ngIf="isIconName(section.icon)">{{ section.icon }}</span>
          {{ section.name }}
        </button>
      </nav>

      <section class="landing-cards">
        <article class="landing-card" *ngFor="let form of forms">
          <span class="landing-card-code">{{ formCode(form.number) }}</span>
          <h3>{{ form.number }}</h3>
          <p>{{ form.title }}</p>
          <p class="landing-card-subtitle" *ngIf="form.subtitle">{{ form.subtitle }}</p>
          <button type="button" class="landing-card-action" (click)="selectForm.emit(form)">
            Diligenciar
            <span class="material-icons">arrow_forward</span>
          </button>
        </article>
      </section>
    </main>
  </div>
</div>
